import {
  AUTH_EMAIL_LOGIN,
  AUTH_MAGIC_LINK_LOGIN
} from 'portal/constants/Routes';
import {
  buttonContainerStyles,
  buttonStyles,
  ctaContainerStyles,
  linkButtonStyles,
  loginContainerStyles
} from 'auth/AuthStyles';

import { DARK_GRAY, GRAY, WHITE_TEXT } from 'styles/Colors';
import { EMAIL_PATTERN, SET_DATA } from 'helpers/Constants';
import { postData } from 'helpers/RequestHelper';
import { useDispatch, useSelector } from 'react-redux';
import AuthLayout from 'auth/AuthLayout';
import Button from '@opploans/button-component/Button';
import Email from 'fields/Email';
import LinkButton from '@opploans/link-button-component/LinkButton';
import PhoneNumberInput from 'fields/PhoneNumberInput';
import React from 'react';

function AuthEmailPhoneNumberVerification({ navigate }) {
  const [loading, setLoading] = React.useState(false);
  const dispatch = useDispatch();
  const socialSecurityNumber = useSelector(
    (state) => state.socialSecurityNumber
  );
  const [email, setEmail] = React.useState('');
  const [emailError, setEmailError] = React.useState('');
  const [phoneNumber, setPhoneNumber] = React.useState('');

  const hrContainerStyles = {
    width: '90%',
    textAlign: 'center',
    borderBottom: '1px solid #BDBDBD',
    lineHeight: '0.1rem',
    margin: '2rem auto',
    color: DARK_GRAY,
    span: {
      background: WHITE_TEXT,
      padding: '0 1rem'
    }
  };

  const containerStyles = {
    ' input:disabled': {
      background: GRAY
    }
  };

  const onSubmit = async () => {
    if (emailError) {
      return;
    }

    setLoading(true);
    const response = await postData({
      url: AUTH_MAGIC_LINK_LOGIN,
      body: {
        user: {
          email,
          ssn: socialSecurityNumber,
          phone_number: phoneNumber
        }
      }
    });
    window.AppConfigState.magic_link ||= {};
    window.AppConfigState.magic_link.phone_number = phoneNumber;
    window.AppConfigState.magic_link.email = email;
    window.AppConfigState.magic_link.next_attempt = response.data.next_attempt;

    if (response.data?.error) {
      window.toastr.error(response.data?.error);
      setLoading(false);
    }
    if (response.data?.message) {
      window.toastr.success(null, response.data.message);
    }
    if (response.data?.redirect) {
      navigate(response.data.redirect);
    }
  };

  const returnToSsnPage = () => {
    dispatch({ type: SET_DATA, payload: { ssnConfirmed: false } });
  };

  const validateEmail = () => {
    setEmailError(email && !email.match(EMAIL_PATTERN) ? 'Invalid Email' : '');
  };

  return (
    <AuthLayout
      title='Login With a Secure Link'
      subTitle='Enter the email or mobile phone number associated with your account, and we’ll send you a secure link to log into your account.'
    >
      <div>
        <div css={loginContainerStyles}>
          <div
            role='button'
            aria-hidden='true'
            onKeyPress={(e) => {
              if (e.key === 'Enter' && (email || phoneNumber)) {
                onSubmit();
              }
            }}
            css={containerStyles}
          >
            <Email
              value={email}
              setValue={setEmail}
              error={emailError}
              setError={setEmailError}
              disabled={phoneNumber.length > 0}
              validate={validateEmail}
            />
            <h2 css={hrContainerStyles}>
              <span>Or</span>
            </h2>
            <PhoneNumberInput
              value={phoneNumber}
              setValue={setPhoneNumber}
              disabled={email.length > 0}
              clearEnabled
            />
            <div css={buttonContainerStyles}>
              <Button
                css={[buttonStyles, { margin: '1rem 0' }]}
                onClick={onSubmit}
                loading={loading}
                disabled={(!email && !phoneNumber) || emailError}
              >
                Send Me Login Link
              </Button>
              <Button onClick={returnToSsnPage}>Return to Previous Page</Button>
            </div>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
}

export default AuthEmailPhoneNumberVerification;
